<template>
  <div v-if="!Mail" class="button animated-link br-6" :style="computedStyle">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="Combined_Shape_Copy_2"
        data-name="Combined Shape Copy 2"
        d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
        transform="translate(0 0)"
        :fill="computedStyle.color"
      />
    </svg>

    <span :style="{ color: computedStyle.color }" class="uppercase font-16">{{
      title
    }}</span>
  </div>
  <a
    v-else
    :href="`mailto:${Mail}`"
    class="button animated-link br-6"
    :style="computedStyle"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="Combined_Shape_Copy_2"
        data-name="Combined Shape Copy 2"
        d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
        transform="translate(0 0)"
        :fill="computedStyle.color"
      />
    </svg>

    <span :style="{ color: computedStyle.color }" class="uppercase font-16">{{
      title
    }}</span>
  </a>
</template>

<script>
export default {
  props: {
    Mail: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: "#ffffff"
    },
    color: {
      type: String,
      default: "#00A3E0"
    },
    title: {
      type: String,
      default: "discover more"
    },
    padding: {
      type: String,
      default: "0 10px"
    }
  },
  computed: {
    computedStyle() {
      return {
        backgroundColor: this.background,
        color: this.color,
        padding: this.padding
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  min-width: 166px;
  width: max-content;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 6px;
  }
}
</style>
